var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "banner_wrapper", style: _vm.bannerWrapperStyle },
    [
      _c("ins", {
        ref: "kakaoAdAreaEl",
        staticClass: "kakao_ad_area",
        attrs: {
          "data-ad-unit": _vm.bannerAdUnitId,
          "data-ad-onfail": _vm.failCallbackName
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }